import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 1);
  animation: ${fadeIn} 0.2s ease-out;
`;

const CircularSpinner = styled.div<{ $size: string; $color: string }>`
  width: ${({ $size }): string => $size};
  height: ${({ $size }): string => $size};
  border: 4px solid #e2e8f0;
  border-top: 4px solid ${({ $color }): string => $color};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const Label = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: #232323;
`;

type LoadingOverlayProps = {
  label?: string;
};

export function LoadingOverlay({
  label = 'Loading...',
}: Readonly<LoadingOverlayProps>): JSX.Element {
  return (
    <Overlay role="status" aria-live="polite">
      <CircularSpinner $size="1.75rem" $color="var(--rg-primary-color, #232323)" />
      <Label>{label}</Label>
    </Overlay>
  );
}
